import * as joint from '@clientio/rappid';

import { BaseLinkVerticeCalculator } from './BaseLinkVerticeCalculator';
import { MouseMoveRequirements } from './link-adjust-types';
import { CustomRouter } from '../custom-router/CustomRouter';

export class LinkAdjustToolEvent {
  static handleMouseMove(
    mouseEvent: MouseEvent,
    buttonView: joint.dia.ToolView,
    linkView: joint.dia.LinkView,
    eventRequirements: MouseMoveRequirements,
    verticeCalculater: BaseLinkVerticeCalculator,
    subflowPosition?: joint.g.PlainPoint,
    subflowSize?: joint.dia.Size,
  ) {
    const { relatedVerticeIndex, element, vertices, startPoint, startOffset, startPointPrev, startMouseX, startMouseY } = eventRequirements;
    const newVertices = [];
    //@ts-ignore
    const sourcePoint = linkView.sourcePoint as joint.g.PlainPoint;
    //@ts-ignore
    const targetPoint = linkView.targetPoint as joint.g.PlainPoint;

    for (let i = 0; i < vertices.length; i++) {
      // For start segment
      if (i === 0 && relatedVerticeIndex === 0) {
        if (buttonView.options.direction === 'horizontal') {
          verticeCalculater.setFirstHorizontalVertices(
            {
              relatedVerticeIndex,
              sourcePoint,
              targetPoint,
              sourceAnchor: linkView.model.attributes.source.anchor.name as string,
              targetAnchor: linkView.model.attributes.target.anchor.name as string,
              startPoint,
              startOffset,
              startPointPrev,
              vertices,
              startMouseX,
              startMouseY,
              subflowPosition,
              subflowSize,
            },
            newVertices,
            mouseEvent,
            i,
          );
        } else {
          verticeCalculater.setFirstVerticalVertices(
            {
              relatedVerticeIndex,
              sourcePoint,
              targetPoint,
              sourceAnchor: linkView.model.attributes.source.anchor.name as string,
              targetAnchor: linkView.model.attributes.target.anchor.name as string,
              startPoint,
              startOffset,
              startPointPrev,
              vertices,
              startMouseX,
              startMouseY,
              subflowPosition,
              subflowSize,
            },
            newVertices,
            mouseEvent,
            i,
          );
        }
      } else if (i === vertices.length - 1 && relatedVerticeIndex === vertices.length) {
        // For end segment
        if (buttonView.options.direction === 'horizontal') {
          verticeCalculater.setLastHorizontalVertices(
            {
              relatedVerticeIndex,
              sourcePoint,
              targetPoint,
              sourceAnchor: linkView.model.attributes.source.anchor.name as string,
              targetAnchor: linkView.model.attributes.target.anchor.name as string,
              startPoint,
              startOffset,
              startPointPrev,
              vertices,
              startMouseX,
              startMouseY,
              subflowPosition,
              subflowSize,
            },
            newVertices,
            mouseEvent,
            i,
          );
        } else {
          verticeCalculater.setLastVerticalVertices(
            {
              relatedVerticeIndex,
              sourcePoint,
              targetPoint,
              sourceAnchor: linkView.model.attributes.source.anchor.name as string,
              targetAnchor: linkView.model.attributes.target.anchor.name as string,
              startPoint,
              startOffset,
              startPointPrev,
              vertices,
              startMouseX,
              startMouseY,
              subflowPosition,
              subflowSize,
            },
            newVertices,
            mouseEvent,
            i,
          );
        }
      } else {
        // For segments in between
        if (buttonView.options.direction === 'vertical') {
          verticeCalculater.setMidVerticalVertices(
            {
              relatedVerticeIndex,
              sourcePoint,
              targetPoint,
              sourceAnchor: linkView.model.attributes.source.anchor.name as string,
              targetAnchor: linkView.model.attributes.target.anchor.name as string,
              startPoint,
              startOffset,
              startPointPrev,
              vertices,
              startMouseX,
              startMouseY,
              subflowPosition,
              subflowSize,
            },
            newVertices,
            mouseEvent,
            i,
          );
        } else {
          verticeCalculater.setMidHorizontalVertices(
            {
              relatedVerticeIndex,
              sourcePoint,
              targetPoint,
              sourceAnchor: linkView.model.attributes.source.anchor.name as string,
              targetAnchor: linkView.model.attributes.target.anchor.name as string,
              startPoint,
              startOffset,
              startPointPrev,
              vertices,
              startMouseX,
              startMouseY,
              subflowPosition,
              subflowSize,
            },
            newVertices,
            mouseEvent,
            i,
          );
        }
      }
    }
    const newNewVertices = newVertices.map((el) => new joint.g.Point(el.x, el.y).snapToGrid(10));
    element.vertices(newNewVertices);
  }

  static getIrregularMargin(anchor: string): number {
    return CustomRouter.getIrregularMargin(anchor);
  }

  static getEventRequirements(
    buttonEvent: joint.dia.Event,
    buttonView: joint.dia.ToolView,
    linkView: joint.dia.LinkView,
  ): MouseMoveRequirements {
    const startMouseX = buttonEvent.clientX;
    const startMouseY = buttonEvent.clientY;
    const relatedVerticeIndex: number = buttonView.options.relatedVerticeIndex;
    const startOffset: number = buttonView.options.direction === 'vertical' ? buttonEvent.offsetX : buttonEvent.offsetY;
    const vertices = linkView.model.vertices();
    let startPoint = 0;
    let startPointPrev = 0;
    if (relatedVerticeIndex === 0) {
      startPoint = buttonView.options.direction === 'vertical' ? vertices[relatedVerticeIndex].x : vertices[relatedVerticeIndex].y;
      // @ts-ignore
      startPointPrev = buttonView.options.direction === 'vertical' ? linkView.sourcePoint.x : linkView.sourcePoint.y;
    } else if (relatedVerticeIndex === vertices.length) {
      // @ts-ignore
      startPoint = buttonView.options.direction === 'vertical' ? linkView.targetPoint.x : linkView.targetPoint.y;
      startPointPrev =
        buttonView.options.direction === 'vertical' ? vertices[relatedVerticeIndex - 1].x : vertices[relatedVerticeIndex - 1].y;
    } else {
      startPoint = buttonView.options.direction === 'vertical' ? vertices[relatedVerticeIndex].x : vertices[relatedVerticeIndex].y;
      startPointPrev =
        buttonView.options.direction === 'vertical' ? vertices[relatedVerticeIndex - 1].x : vertices[relatedVerticeIndex - 1].y;
    }
    const element = linkView.model.graph.getCell(linkView.model.id) as joint.dia.Link;

    return { relatedVerticeIndex, element, vertices, startPoint, startOffset, startPointPrev, startMouseX, startMouseY };
  }
}
